skrilla.controller('createUserDepositModalCtrl', function ($scope, searchService, cacheService, modalService, currencyService, validationService) {
    $scope.validate = {}
    $scope.accounts = cacheService.getObjectOrElse("userDepositAccounts", function(){
        modalService.dismissAll();
    });

    var description = "You deposited funds.";
    $scope.newDeposit = {
        creditId: getAccountId('AVAILABLE'),
        debitId: getAccountId('CASH'),
        creditDescription: description,
        debitDescription: description,
        isDeposit: true
    }

    $scope.create = function () {
        if(validate()) {
            modalService.confirm("Are you sure you'd like to create this deposit?", function () {
                const request = {
                    ...$scope.newDeposit,
                    amount: currencyService.multiply($scope.newDeposit.amount, $scope.accounts[0].currency)
                }
                searchService.post("manualTransactions", request, "Manual Deposit Successfully Created!").then(function (response) {
                    modalService.dismissAll();
                });
            });
        }
    }

    function validate() {
        let inputs = [
            validationService.buildFieldValidationObj("reason", validationService.isNotEmpty($scope.newDeposit.reason), "Please provide a reason"),
            validationService.buildFieldValidationObj("amount", validationService.isNumberGreaterThanZero($scope.newDeposit.amount), "Please provide a valid deposit amount"),
        ]

        return validationService.validateForm(inputs, $scope.validate)
    }


    function getAccountId(purpose){
        var accounts = $scope.accounts.filter(function(it){
            return it.purpose === purpose;
        });
        if(accounts.length === 0){
            alert("Unable to find account with purpose " + purpose);
            modalService.dismissAll();
        }
        return accounts[0].id;
    }
});